import { useHistory } from 'react-router-dom';
import { resetPwaSessionToEntry, toastError } from 'utils';
import { channelEntryPath, clearFmaSession, readFmaSession, } from '../../find-my-account/utils';
export function useSessionExpiryGuard() {
    const history = useHistory();
    return function checkExpired() {
        const session = readFmaSession();
        const isExpired = !!session?.verificationExpiresAt &&
            new Date(session.verificationExpiresAt) <= new Date();
        if (!isExpired)
            return false;
        const redirectPath = channelEntryPath();
        toastError('Your session has expired. Please try again.');
        clearFmaSession();
        resetPwaSessionToEntry();
        history.push(redirectPath);
        return true;
    };
}
